import React from 'react';
import { Stack } from '@mui/material';
import { StepTitle } from '../StepTitle';
import { StepIndicatorStates } from 'components/StepIndicator';
import { useIntl } from 'react-intl';
import { ExplanationStepActive } from './ExplanationStepActive';
import { ExplanationStepCompleted } from './ExplanationStepCompleted';

export type ExplanationForm = {
  reasonId: number,
  note: string
  attachments: File[]
}

interface ExplanationStepProps {
  state: StepIndicatorStates
  explanationFrom?: ExplanationForm
  completeStep(explanationForm: ExplanationForm): void
  onEditStep(): void,
}

export const ExplanationStep: React.FC<ExplanationStepProps> = ({ state, completeStep, onEditStep, explanationFrom }) => {
  const { formatMessage } = useIntl();

  return (
    <Stack>
      <StepTitle
        number={3}
        state={state}
        incompleteTitle={formatMessage({ id: 'FindServiceCall.ExplanationStep.IncompleteTitle', defaultMessage: 'Reason for the request' })}
        activeTitle={formatMessage({ id: 'FindServiceCall.ExplanationStep.ActiveTitle', defaultMessage: 'What is the reason for your request?' })}
        completedTitle={formatMessage({ id: 'FindServiceCall.ExplanationStep.CompletedTitle', defaultMessage: 'Reason for the request' })}
        onEditClick={onEditStep}
      />
      <Stack marginLeft={7} gap={3}>
        {state === 'active' &&
          <ExplanationStepActive completeStep={completeStep}
            reasonId={explanationFrom?.reasonId}
            userNote={explanationFrom?.note}
            attachments={explanationFrom?.attachments ?? []} />
        }
        {state === 'complete' && explanationFrom?.reasonId &&
          <ExplanationStepCompleted reasonId={explanationFrom.reasonId} />
        }
      </Stack>
    </Stack>
  );
};